
import DataFetcher from "../../hooks/DataFetcher";
import BlockImageCabecera from "../../components/BlockImageCabecera";


const url =
  "https://be-portales.utpl.edu.ec/jsonapi/node/posgrados/3abeb8df-435e-409d-b790-a6322e57f265" +
  "?include=field_imagen_portada.field_media_image" +
  "&fields[node--posgrados]=title,field_precio,field_duracion,field_inicio_clases,field_atributo_1,field_atributo_2,field_atributo_3,field_imagen_portada,field_texto_portada,body" +
  "&fields[media--image]=field_media_image" +
  "&fields[file--file]=uri";

export default function MaestriaFinanzas() {
  const DataDisplay = ({ data }) => (
    <div>
      <BlockImageCabecera
        src={data.imagen_portada}
        title={
          <div
            dangerouslySetInnerHTML={{
              __html: data.field_texto_portada || "",
            }}
          />
        }
      />

      <h1>{data.titulo}</h1>
      <p><strong>Precio:</strong> {data.precio}</p>
      <p><strong>Duración:</strong> {data.duracion}</p>
      <p><strong>Inicio:</strong> {data.inicio}</p>

      <div dangerouslySetInnerHTML={{ __html: data.descripcion }} />
    </div>
  );

  return (
    <DataFetcher url={url}>
      {(data) => <DataDisplay data={data} />}
    </DataFetcher>
  );
}